// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type RecentlyActivatedItemTemplatesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ItemTemplateFilter>;
  order?: Types.InputMaybe<Types.ItemTemplateOrder>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type RecentlyActivatedItemTemplatesQuery = { __typename?: 'Query', itemTemplates: Array<{ __typename?: 'ItemTemplate', id: string, name: string, activatedAt?: Types.Scalars['DateTime']['input'] | null | undefined }> };

export type RecentlyActivatedItemTemplatesFragment = { __typename?: 'ItemTemplate', id: string, name: string, activatedAt?: Types.Scalars['DateTime']['input'] | null | undefined };

export const RecentlyActivatedItemTemplatesFragmentDoc = gql`
    fragment RecentlyActivatedItemTemplates on ItemTemplate {
  id
  name
  activatedAt
}
    `;
export const RecentlyActivatedItemTemplatesDocument = gql`
    query RecentlyActivatedItemTemplates($filter: ItemTemplateFilter, $order: ItemTemplateOrder, $limit: Int) {
  itemTemplates(filter: $filter, order: $order, limit: $limit) {
    ...RecentlyActivatedItemTemplates
  }
}
    ${RecentlyActivatedItemTemplatesFragmentDoc}`;

/**
 * __useRecentlyActivatedItemTemplatesQuery__
 *
 * To run a query within a React component, call `useRecentlyActivatedItemTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentlyActivatedItemTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentlyActivatedItemTemplatesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRecentlyActivatedItemTemplatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RecentlyActivatedItemTemplatesQuery, RecentlyActivatedItemTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RecentlyActivatedItemTemplatesQuery, RecentlyActivatedItemTemplatesQueryVariables>(RecentlyActivatedItemTemplatesDocument, options);
      }
export function useRecentlyActivatedItemTemplatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecentlyActivatedItemTemplatesQuery, RecentlyActivatedItemTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RecentlyActivatedItemTemplatesQuery, RecentlyActivatedItemTemplatesQueryVariables>(RecentlyActivatedItemTemplatesDocument, options);
        }
// @ts-ignore
export function useRecentlyActivatedItemTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<RecentlyActivatedItemTemplatesQuery, RecentlyActivatedItemTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RecentlyActivatedItemTemplatesQuery, RecentlyActivatedItemTemplatesQueryVariables>;
export function useRecentlyActivatedItemTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RecentlyActivatedItemTemplatesQuery, RecentlyActivatedItemTemplatesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<RecentlyActivatedItemTemplatesQuery | undefined, RecentlyActivatedItemTemplatesQueryVariables>;
export function useRecentlyActivatedItemTemplatesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RecentlyActivatedItemTemplatesQuery, RecentlyActivatedItemTemplatesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RecentlyActivatedItemTemplatesQuery, RecentlyActivatedItemTemplatesQueryVariables>(RecentlyActivatedItemTemplatesDocument, options);
        }
export type RecentlyActivatedItemTemplatesQueryHookResult = ReturnType<typeof useRecentlyActivatedItemTemplatesQuery>;
export type RecentlyActivatedItemTemplatesLazyQueryHookResult = ReturnType<typeof useRecentlyActivatedItemTemplatesLazyQuery>;
export type RecentlyActivatedItemTemplatesSuspenseQueryHookResult = ReturnType<typeof useRecentlyActivatedItemTemplatesSuspenseQuery>;
export type RecentlyActivatedItemTemplatesQueryResult = ApolloReactCommon.QueryResult<RecentlyActivatedItemTemplatesQuery, RecentlyActivatedItemTemplatesQueryVariables>;